import { z as z$1 } from "zod";

// src/models/gender.ts
let CustomerGender = /* @__PURE__ */ function(CustomerGender) {
	CustomerGender["Female"] = "Female";
	CustomerGender["Male"] = "Male";
	CustomerGender["Other"] = "Other";
	CustomerGender["Unknown"] = "Unknown";
	return CustomerGender;
}({});
const customerGenderSchema = z$1.enum(CustomerGender);
const US_CORE_BIRTHSEX_EXTENSION_URL = "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex";
/** Map customer profile gender to FHIR Patient.gender (Canvas requires lowercase). */
function customerGenderToFhirAdministrativeGender(gender) {
	if (gender == null) return "unknown";
	const normalized = String(gender).toLowerCase();
	if (normalized === "female") return "female";
	if (normalized === "male") return "male";
	if (normalized === "other") return "other";
	return "unknown";
}
/** Map customer gender to US Core birthsex (required Canvas Patient extension on create). */
function customerGenderToUsCoreBirthsex(gender) {
	if (gender == null) return "UNK";
	const normalized = String(gender).toLowerCase();
	if (normalized === "female") return "F";
	if (normalized === "male") return "M";
	if (normalized === "other") return "OTH";
	return "UNK";
}
const SURVEY_GENDER_TO_CUSTOMER = {
	Woman: "Female",
	Man: "Male",
	"Nonbinary or gender-diverse": "Other",
	Other: "Other"
};
/** Survey label → canonical customer enum (Woman→Female, Man→Male, Nonbinary→Other, else Unknown). */
function genderFromSurveyAnswer(raw) {
	if (!raw?.trim()) return "Unknown";
	return SURVEY_GENDER_TO_CUSTOMER[raw.trim()] ?? "Unknown";
}
/** Human-readable label for UI and exports. Unknown maps to "Prefer not to say". */
function displayGender(gender) {
	switch (gender) {
		case "Female": return "Female";
		case "Male": return "Male";
		case "Other": return "Other";
		case "Unknown": return "Prefer not to say";
		default: return "Prefer not to say";
	}
}
/** True when profile gender differs from the survey-derived enum. */
function customerGenderDiffersFromSurvey(customerGender, surveyGenderRaw) {
	if (!surveyGenderRaw?.trim()) return false;
	return genderFromSurveyAnswer(surveyGenderRaw) !== customerGender;
}

export { CustomerGender, US_CORE_BIRTHSEX_EXTENSION_URL, customerGenderDiffersFromSurvey, customerGenderSchema, customerGenderToFhirAdministrativeGender, customerGenderToUsCoreBirthsex, displayGender, genderFromSurveyAnswer };
//# sourceMappingURL=gender.mjs.map